import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';

export default class Size extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true
        };
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/constant/get", {
            id: this.getCurrentFormId(),
            type: 3
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/constant/save", {
            id: this.state.id,
            title: this.state.data.record.title,
            titleEn: this.state.data.record.titleEn,
            titleAr: this.state.data.record.titleAr,
            type: this.state.data.record.type,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshLis();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
                <div className="modal-dialog ui-draggable">
                    <div className="modal-content">
                        <div className="modal-body" style={{ "padding": "0" }}>
                            <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title">
                                    {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات" : "افزودن جدید"}
                                </h4>
                            </div>
                            <div className="modal-body">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label for="name" className="title1">عنوان</label><span className="red">*</span>
                                                <input defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                            </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">عنوان لاتین</label>
                                            <input defaultValue={this.state.data.record.titleEn} onChange={e => this.state.data.record.titleEn = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">عنوان عربی</label>
                                            <input defaultValue={this.state.data.record.titleAr} onChange={e => this.state.data.record.titleAr = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                            <button type="button" className="btn btn-default btn-smoke" onClick={e => this.closeMe()}>انصراف</button>
                                <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                    ذخیره
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}